import React, { ReactNode } from 'react';

export interface SectionProps {
  id: string;
  label: string;
  path: string;
  children: ReactNode;
  disabled?: boolean;
}

// This component is just a wrapper - SectionedPage extracts the props
// and renders the children directly
const Section: React.FC<SectionProps> = ({ children }) => {
  return <>{children}</>;
};

export default Section;
